import ModalDeleteInvoice from './ModalDeleteInvoice';

export default ModalDeleteInvoice;
